module.exports = new __parcel__URL__("slack.ba8f92ff.png").toString();